export default "<div class=\"vm-progress-line\"></div>"